import { queries } from "../../shared/queries";
import {
  useSessionTenantEdgeOrigin,
  useSessionTenantEdgeWildcardDomain,
} from "./useSessionTenantOrigin";
import { useQuery } from "@rocicorp/zero/react";

// A tenant may register more than one custom domain; the earliest is canonical.
export function useTenantCustomDomain(): string | null {
  const [domains] = useQuery(queries.tenantCustomDomains());
  const edgeHostname = new URL(useSessionTenantEdgeOrigin()).hostname;
  const edgeWildcardDomain = useSessionTenantEdgeWildcardDomain();
  return (
    domains?.find(
      ({ id, domain }) =>
        !id.startsWith("legacy-public-") &&
        domain !== edgeHostname &&
        domain !== edgeWildcardDomain
    )?.domain ?? null
  );
}
